window.renderCartPageContent = async function renderCartContentItems() {
  const html = await fetch('/cart', { credentials: 'same-origin' }).then(r => r.text());
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const freshItems = [...doc.body.querySelectorAll('cart-coupon-discount')];
  const liveItems = [...document.querySelectorAll('cart-coupon-discount')];

  if (freshItems.length === 0) {
    const cartContainer = document.querySelector('.cart-content');
    const freshContainer = doc.querySelector('.cart-content');
    if (cartContainer && freshContainer) {
      cartContainer.innerHTML = freshContainer.innerHTML;
    }
    return;
  }

  const findFresh = (liveEl) => {
    const id = liveEl.id;
    if (id) {
      const n = doc.getElementById(id);
      if (n && n.classList.contains('cart-content-item')) return n;
    }

    const key = liveEl.getAttribute('data-key');
    if (key) {
      const n = doc.querySelector(`cart-coupon-discount[data-key="${CSS.escape(key)}"]`);
      if (n) return n;
    }

    const line = liveEl.getAttribute('data-line');
    if (line) {
      const n = doc.querySelector(`cart-coupon-discount[data-line="${CSS.escape(line)}"]`);
      if (n) return n;
    }

    const i = liveItems.indexOf(liveEl);
    return freshItems[i] || null;
  };

  liveItems.forEach(el => {
    const f = findFresh(el);
    if (f) el.innerHTML = f.innerHTML;
  });
};



// document.addEventListener('DOMContentLoaded', () => {
//   if (!window.location.pathname.includes('/cart')) return;

//   const initObserver = () => {
//     const target = document.querySelector('cart-coupon-discount');
//     if (!target) {
//       setTimeout(initObserver, 1000);
//       return;
//     }

//     const observer = new MutationObserver(() => {
//       setTimeout(() => {
//         if (typeof window.renderCartPageContent === 'function') {
//           window.renderCartPageContent();
//         }
//       }, 3000);
//     });

//     observer.observe(target, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//       characterData: true,
//     });
//   };

//   initObserver();
// });
